(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.nodeMeeting = {
    attach: function (context, settings) {
      once('nodeMeeting', '.meeting', context).forEach(function (block) {
        $(block).find(".toggle").on("click", function () {
          $(block).toggleClass('is-open');
          if ($(block).hasClass('is-open')) {
            var hBlock = $(block).find(".meeting-content .inner > div").outerHeight();
            $(block).find(".meeting-content").css("max-height", hBlock);
          } else {
            $(block).find(".meeting-content").css("max-height", "0");
          }
        });
      });
    }
  }
})(jQuery, Drupal, once, drupalSettings);
